













import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import getLevelsPremadeBySubjectType from '@/utils/common/get-levels-premade-by-subject-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FilterDropdown from '@/main-components/pre-collections-new/pre-collection-filter/FilterDropdown.vue';
import getLevelPremadePaper from '@/utils/common/get-level-premade-paper';

@Component({
  components: {
    FilterDropdown,
  },
})
export default class FilterLevel extends Vue {
  @Prop({ required: true })
  queries!: PreCollectionsParams;

  getLevel = getLevelPremadePaper;
  levels: number[] = getLevelsPremadeBySubjectType(this.queries.subjectType);

  created() {
    this.updateAvailLevels();
  }

  @Watch('queries.subjectType')
  onSubjectTypeChange() {
    this.updateAvailLevels();
  }

  updateAvailLevels() {
    if (this.queries) {
      const currentSubjectType = this.queries.subjectType;
      this.levels = getLevelsPremadeBySubjectType(currentSubjectType);
    }
  }

  updateLevels(levels: number[]) {
    this.queries.levels = levels;

    this.$emit('submitFilter', true);
  }
}
